import {useAuthStore} from "@src/stores/auth";
import {db} from "@src/services/db";

export function EditMessageListener() {
    const auth = useAuthStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets.private(`user.${userId}`)
        .listen(".EditMessageEvent", async (event: any) => {
            const message = event.message
            await db.messages.update(message.id, {
                message: message.message,
                is_edited: message.is_edited,
                updated_at: message.updated_at,
            } as any);
            if (!message.chat_session_id) {
                return;
            }

            const session = await db.sessions.get(message.chat_session_id)

            if (session && session.last_message?.id === message.id) {
                await db.sessions.update(message.chat_session_id, {
                    last_message: message,
                    updated_at: message.updated_at,
                })
            }
        });
}